import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 项目类型
 */
class Type extends UltMeta {
    BUY = new Meta(1, "采购");
    SELL = new Meta(2, "销售");
}

export const TYPE = new Type();

/**
 * 费用类型
 */
class CostType extends UltMeta {
    DEPOSIT = new Meta(1, "履约保证金");
    ORDER_DEPOSIT = new Meta(0, "订单保证金");
    LOAN = new Meta(2, "货款");
}

export const COST_TYPE = new CostType();

/**
 * 费用类型 + 服务费  主要是 供应链端收款，客户端付款
 */
class CollectCostType extends UltMeta {
    DEPOSIT = new Meta(1, "履约保证金");
    ORDER_DEPOSIT = new Meta(0, "订单保证金");
    LOAN = new Meta(2, "货款");
    BUSINESS_SERVICE_FEE = new Meta(3, "业务服务费");
    REGULATORY_SERVICE_FEE = new Meta(4, "监管服务费");
    OTHER = new Meta(5, "其他");
}

export const COLLECT_COST_TYPE = new CollectCostType();

/**
 * 付款方式
 */
class PaymentWay extends UltMeta {
    CASH = new Meta(1, "现金");
    BANK_TRANSFER = new Meta(2, "银行转账");
    LETTER_OF_CREDIT = new Meta(3, "信用证");
    BANK_ACCEPTANCE = new Meta(4, "银行承兑汇票");
    COMMERCIAL_ACCEPTANCE = new Meta(5, "商业承兑汇票");
    LIQUIDITY_LOAN = new Meta(6, "流动贷");
}

export const PAYMENT_WAY = new PaymentWay();

/**
 * 收付款状态
 */
class State extends UltMeta {
    PENDING_CONFIRMATION = new Meta(1, "待确认或确认中");
    COMPLETED = new Meta(2, "付款完成或收款完成");
    REJECTED = new Meta(3, "已驳回");
}

export const STATE = new State();

/**
 * 收付款查询状态
 */
class StateQuery extends UltMeta {
    TO_BE_CONFIRMED = new Meta(0, "待确认");
    PENDING_CONFIRMATION = new Meta(1, "确认中");
    // 收款 -- 收款完成  付款 -- 付款完成
    COMPLETED = new Meta(2, "付款完成或收款完成");
    REJECTED = new Meta(3, "已驳回");
}

export const STATE_QUERY = new StateQuery();
